// extracted by mini-css-extract-plugin
export default {"link":"bK-z","disabled":"cK-z"};